import React, { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { Container, Button } from 'reactstrap';
import Question from './Question';
import ListBox from './ListBox';
import Header from '../../../component/Header';
import { QUESTIONS } from '../../../context/staticData';
import 'react-spring-bottom-sheet/dist/style.css';
import { useDiet } from '../../../hooks/useDiet';
import { AppContext } from '../../../context/app-context';
import { sendFirebaseEvent } from '../../../helper/mobile';

const PaidQuestion = () => {

    const [state, dispatch] = useContext(AppContext);
    
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState();
    const [selectedOption, setSelectedOption] = useState([]);
    const { dietPlanGoogleForm } = useDiet();
    const { dietPlanId } = useParams();

    useEffect(() => {
        if(state?.healthConditions){
            let hcarray = [];
            state.healthConditions.forEach(element => {
                if(element.isChecked){
                    hcarray.push(element.value)
                }
            });
            setSelectedOption([{name: 'healthConditions', option: hcarray}])
        }
    }, []);

    const questionOnClickHandler = (type) => {
        setCurrentQuestion(QUESTIONS.find(obj => obj.name===type))
        setOpen(true)
    }
    const arrayMarge = opData => {
        const optionDArr = selectedOption.map(obj => {
            if(obj.name === currentQuestion.name)
                return {name: currentQuestion.name, option: opData}
            else
                return obj
        })
        setSelectedOption(optionDArr)
    }
    const listBoxClickHandler = (liData) => {
        if(selectedOption.length > 0){
            const checkElement = selectedOption.find(obj => obj.name === currentQuestion.name);
            if(checkElement){
                if(currentQuestion.isSingle || ((checkElement.name === "healthConditions" || checkElement.name === "allergies") && liData === "none")) {
                    arrayMarge([liData]);
                } else {
                    if(checkElement.option.includes(liData)){
                        const op = checkElement.option.filter(o => o !== liData);
                        if(op.length > 0){
                            arrayMarge(op);
                        }else {
                            setSelectedOption(selectedOption.filter(s => s.name !== currentQuestion.name))
                        }
                    } else {
                        let optionD = checkElement.option;
                        if(liData !== "none") {
                            optionD = optionD.filter(o => o !== "none");
                        }
                        optionD.push(liData);
                        if(optionD.length > 0){
                            arrayMarge(optionD);
                        }else {
                            setSelectedOption(selectedOption.filter(s => s.name !== currentQuestion.name))
                        }
                    }
                }
            }else {
                setSelectedOption([...selectedOption, {name: currentQuestion.name, option: [liData]}])
            }
        }else {
            setSelectedOption([{name: currentQuestion.name, option: [liData]}])
        }

        if(currentQuestion.name === 'medication')
            setOpen(false)

    }

    const onClickClose = () => {
        setOpen(false)
    }

    const onClickDietPlanGoogleForm = (so, dp) => {
        sendFirebaseEvent('diet_plan_generate_click', 'click_event', 'paid');
        dietPlanGoogleForm(so, dp);
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 2000);
    }

    return (
        <>
            <Header title="Diet plan" />
            <Container>
                <h2 className='mt-4 mb-5 paid-question-header-title'>We are almost there, get started with your customised diet plan</h2>
                {
                    QUESTIONS.map(obj => <Question key={obj.id} questionOnClickHandler={questionOnClickHandler} questionObj={obj} selectedOption={selectedOption} />)
                }
                <BottomSheet open={open} onDismiss={() => setOpen(false)}>
                    <ListBox currentQuestion={currentQuestion} listBoxClickHandler={listBoxClickHandler} selectedOption={selectedOption} onClickClose={onClickClose} />
                </BottomSheet>
            </Container>
            <div className="empty-space-82"></div>
            <div className="fix-div-button">
                {
                    isLoading ? <Button className="risk-btn" disabled={true}>Generate my diet plan</Button> :
                    <Button className="risk-btn" onClick={() => onClickDietPlanGoogleForm(selectedOption, dietPlanId)} disabled={(selectedOption.length <= 5 ? true : false) || isLoading}>Generate my diet plan</Button>
                }
                
            </div>
        </>
    )
}

export default PaidQuestion;